import { withNavigationWatcher } from "./contexts/navigation";
import Home from "./pages/Home/Home";
import NewProfiles from "./pages/AllProfiles/NewProfiles";
import AllProfiles from "./pages/AllProfiles/AllProfiles";
import AdminUsers from "./pages/AdminUsers/AdminUsers";
import EditProfiles from "./pages/AllProfiles/EditProfiles";
import FailProfiles from "./pages/AllProfiles/FailProfiles";
import FreezedProfiles from "./pages/AllProfiles/FreezedProfiles";
import DellProfiles from "./pages/AllProfiles/DellProfiles";
import BlockedProfiles from "./pages/AllProfiles/BlockedProfiles";
import Reports from "./pages/Reports/Reports";
import GPTUsers from "./pages/GPTUsers/GPTUsers";
import Orders from "./pages/Orders/Orders";
import Analytics from "./pages/Home/Analytics";
import DeleteRequests from "./pages/DeleteRequests/DeleteRequests";
import SupportMessages from "./pages/SupportMessages/SupportMessages";
import UserChats from "./pages/UserChats/UserChats";
import Broadcasts from "./pages/Broadcasts/Broadcasts";
import GameCupid from "./pages/GameCupid/GameCupid";
import DateCards from "./pages/DateCards/DateCards";
import DeletionMessages from "./pages/DeletionMessages/DeletionMessages";
import Settings from "./pages/Settings/Settings";
import Documents from "./pages/Documents/Documents";
import FamilyStories from "./pages/FamilyStories/FamilyStories";
import AuthProviders from "./pages/AuthProviders/AuthProviders";
import GoogleApiKeys from "./pages/GoogleApiKeys/GoogleApiKeys";

const routes = [
	{
		path: "/",
		element: Home,
	},
	{
		path: "/all-profiles",
		element: AllProfiles,
	},
	{
		path: "/new-profiles",
		element: NewProfiles,
	},
	{
		path: "/edit-profiles",
		element: EditProfiles,
	},
	{
		path: "/fail-profiles",
		element: FailProfiles,
	},
	{
		path: "/freezed-profiles",
		element: FreezedProfiles,
	},
	{
		path: "/dell-profiles",
		element: DellProfiles,
	},
	{
		path: "/blocked-profiles",
		element: BlockedProfiles,
	},
	{
		path: "/users",
		element: AdminUsers,
	},
	{
		path: "/reports",
		element: Reports,
	},
	{
		path: "/delete-requests",
		element: DeleteRequests,
	},
	{
		path: "/support-messages",
		element: SupportMessages,
	},
	{
		path: "/user-chats",
		element: UserChats,
	},
	{
		path: "/gpt-users",
		element: GPTUsers,
	},
	{
		path: "/orders",
		element: Orders,
	},
	{
		path: "/date-cards",
		element: DateCards,
	},
	{
		path: "/game-cupid",
		element: GameCupid,
	},
	{
		path: "/deletion-messages",
		element: DeletionMessages,
	},
	{
		path: "/analytics",
		element: Analytics,
	},
	{
		path: "/broadcasts",
		element: Broadcasts,
	},
	{
		path: "/settings",
		element: Settings,
	},
	{
		path: "/documents",
		element: Documents,
	},
	{
		path: "/family-stories",
		element: FamilyStories,
	},
	{
		path: "/auth-providers",
		element: AuthProviders,
	},
	{
		path: "/google-api-keys",
		element: GoogleApiKeys,
	},
];

export default routes.map((route) => {
	return {
		...route,
		element: withNavigationWatcher(route.element, route.path),
	};
});
